import axiosRequest from './restapi';

const changeUserStatus = (userId: string, status: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'patch',
      url: `users/${userId}`,
      data: { status },
    },
    userToken
  );
};

export default changeUserStatus;
